/** @format */

/* eslint require-await: "warn" -- Legacy code: do not use as an example. */
import { AxiosRequestConfig } from 'axios';

import { client } from '@toucan/client/global/axios';
import { MarketCode } from '@toucan/client/global/market';

export async function requestPasswordReset(
    email: string,
    market: MarketCode
): Promise<void> {
    const config: AxiosRequestConfig = {
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'X-Market': market.toLowerCase(),
        },
    };

    return client.post(
        '/public-api/v1/user/password-reset/request/',
        {
            email,
        },
        config
    );
}
